<template>
  <div  v-if="respond!==null"  class="cgwrapper" :style="{ background: bgColor() }" >
    <div>
      <div class="title">{{title}}</div>
      <div class="value">{{respond.svalue}}</div>
    </div>
    <div>
      <TrendGoalComponent class="bottomComponent" v-if="trendGoalValue!==null" :value="trendGoalValue" :parentColor="parentColor"  />
    </div>
  </div>
</template>

<script>

  import TrendGoalComponent from "./TrendGoalComponent";

  export default {
    name: 'ColoredGoalWidget',

    components: {
      TrendGoalComponent
    },

    props: {
      widgetData: Object
    },

    data() {
      return {
        respond: null,
        trendGoalValue: null,
        title: '',
        value: 0,
      }
    },

    computed: {
      parentColor() {
        return this.respond ? this.respond.color : ''
      }

    },

    methods: {
      requestData(requester) {
        requester.addExpressionRequest(this.dataCallback, this.widgetData.extname, this.widgetData.expr);
      },

      dataCallback(dto) {
        this.respond = dto

        this.title = dto.title;
        this.trendGoalValue = dto.trendGoalValue
      },

      bgColor() {
        if(this.respond.color) {
          switch(this.respond.color) {
            case 'GREEN':
              return '#29c43c'
            case 'YELLOW':
              return '#ffc000'
            case 'ORANGE':
              return '#ff8600'
            case 'RED':
              return '#c00000'
            case 'BLUE':
              return '#01579b'
          }
        }
        return 'white'
      }

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cgwrapper {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  div.title {
    text-align: center;
    font-size: 200%;
    color: white;
    margin-top: 20px;
  }

  div.value {
    margin-top: 20px;
    text-align: center;
    font-size: 250%;
    color: white;
  }

</style>
